import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) {}

  public get(url: string, options?: any): Observable<any> {
    return this.http.get<any>(url).pipe(retry(1));
  }

  // NOTE: retry(1) intentionally removed here - this method is used for non-idempotent
  // writes (e.g. uploadFile, SaveInterpretationReport, SaveRecommendationsReport). Silently
  // retrying a failed POST risks submitting the same write twice. GET above stays retried
  // since re-fetching data is safe.
  public post(url: string, body: any, options?: any): Observable<any> {
    return this.http.post<any>(url, body, options);
  }

  public put(url: string, body: any, options?: any): Observable<any> {
    return this.http.put<any>(url, body, options);
  }

  public delete(url: string, options?: any): Observable<any> {
    return this.http.delete<any>(url, options);
  }
}
